export const actionNames = {
  REQUEST_LOGIN: '@auth/REQUEST_LOGIN',
  REQUEST_LOGIN_WITH_SESSIONID: '@auth/REQUEST_LOGIN_WITH_SESSIONID',
  REQUEST_LOGIN_WITH_SESSIONID_SUCCESS:
    '@auth/REQUEST_LOGIN_WITH_SESSIONID_SUCCESS',
  REQUEST_LOGIN_WITH_SESSIONID_FAILURE:
    '@auth/REQUEST_LOGIN_WITH_SESSIONID_FAILURE',
  REQUEST_LOGIN_WL: '@auth/REQUEST_LOGIN_WL',
  REQUEST_LOGIN_SUCCESS: '@auth/REQUEST_LOGIN_SUCCESS',
  REQUEST_LOGIN_FAILURE: '@auth/REQUEST_LOGIN_FAILURE',
  LOGOUT: '@auth/LOGOUT',
  LOGOUT_SUCCESS: '@auth/LOGOUT_SUCCESS',
  REVOKE_TOKEN: '@auth/REVOKE_TOKEN',
};

export function requestLogin(email, password) {
  return {
    type: actionNames.REQUEST_LOGIN,
    payload: { email, password },
  };
}

export function requestLoginWithSessionId(sessionId) {
  return {
    type: actionNames.REQUEST_LOGIN_WITH_SESSIONID,
    payload: { sessionId },
  };
}

export function requestLoginWithSessionIdSuccess(sessionId) {
  return {
    type: actionNames.REQUEST_LOGIN_WITH_SESSIONID_SUCCESS,
    payload: { sessionId },
  };
}

export function requestLoginWithSessionIdFailure(sessionId) {
  return {
    type: actionNames.REQUEST_LOGIN_WITH_SESSIONID_FAILURE,
    payload: { sessionId },
  };
}

export function requestLoginWlWithToken(
  token,
  customer_id,
  successFn,
  errorFn
) {
  return {
    type: actionNames.REQUEST_LOGIN_WL,
    payload: { token, customer_id, successFn, errorFn },
  };
}

export function requestLoginSuccess(access) {
  return {
    type: actionNames.REQUEST_LOGIN_SUCCESS,
    payload: access,
  };
}

export function requestLoginFailure(error) {
  return {
    type: actionNames.REQUEST_LOGIN_FAILURE,
    payload: error,
  };
}

export function logout(data = {}) {
  return {
    type: actionNames.LOGOUT,
    payload: data,
  };
}

export function logoutSuccess() {
  return {
    type: actionNames.LOGOUT_SUCCESS,
  };
}

export function revokeToken() {
  return {
    type: actionNames.REVOKE_TOKEN,
  };
}
